import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "tw d-flex align-center justify-center"
};
const _hoisted_2 = {
  md: "4",
  class: "flex justify-start"
};
const _hoisted_3 = {
  class: "d-flex align-center justify-center fill-height"
};
import { onMounted, reactive } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import image from "../../../../public/img/outstandingInvoices.jpg";
import UpgradeDialog from "./UpgradeDialog.vue";
import UpgradePlanDialog from "./UpgradePlanDialog.vue";
import EventTracker from "../../../services/eventTracker";
import { useSupportChat } from '@/composables/useSupportChat';
export default {
  __name: 'SplashPage',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    reportState: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: false
    },
    userService: {
      type: Object,
      required: false
    },
    state: {
      type: Object,
      required: false
    }
  },
  emits: ["closeSplashPage"],
  setup(__props, {
    emit: __emit
  }) {
    const {
      openChat
    } = useSupportChat();
    const props = __props;
    const splashState = reactive({
      openUpgradeDialog: false,
      openUpgradePlanDialog: false,
      me: {}
    });
    const emit = __emit;
    onMounted(async () => {
      splashState.me = await props.userService.me();
      if (props.reportState?.redirectToUpgradeDialog) {
        splashState.openUpgradeDialog = props.reportState?.redirectToUpgradeDialog;
      }
    });
    const closeUpgradeDialog = value => {
      if (value.product?.leanlawProductId === "pro" || value.product?.leanlawProductId === "trial" || value.product?.leanlawProductId === "legacy") {
        if (props.state?.current?.name === "billing.upgradePlan") {
          props.state.go('billing.invoiceInsights');
          return;
        }
        emit("closeSplashPage", value);
      }
      splashState.openUpgradeDialog = false;
    };
    const closeUpgradePlanDialog = () => {
      splashState.openUpgradePlanDialog = false;
    };
    const getLeanLawPro = () => {
      trackEvent("Get LeanLaw Pro", "Opened");
      if (props.reportState?.me?.access?.setup || splashState?.me?.access?.setup) {
        splashState.openUpgradeDialog = true;
      } else {
        splashState.openUpgradePlanDialog = true;
      }
    };
    const contactUs = () => {
      trackEvent("Contact Us", "Opened");
      openChat();
    };
    const trackEvent = (category, action) => {
      EventTracker.trackEvent(props.tracking, category, action, {
        createdAt: new Date().toLocaleDateString("en-US"),
        email: props.reportState?.me?.email ? props.reportState.me?.email : splashState?.me?.email,
        name: props.reportState?.me?.name ? props.reportState.me?.name : splashState?.me?.name,
        role: props.reportState?.me?.role ? props.reportState.me?.role : splashState?.me?.role
      });
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_img = _resolveComponent("v-img");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_v_card, null, {
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createVNode(_component_v_row, {
            class: "p-8"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_row, {
              class: "flex justify-between m-0"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "12",
                md: "5"
              }, {
                default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("p", {
                  class: "m-0 top-title"
                }, "LeanLaw's Cutting-Edge Feature:", -1)), _createVNode(_component_v_card_title, {
                  class: "card-title mb-2"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" Unleash the Power of Your Data Today! ", -1)]))]),
                  _: 1
                }), _cache[4] || (_cache[4] = _createElementVNode("p", {
                  class: "card-paragraph"
                }, " Introducing the most powerful reporting engine in the industry, brought to you by LeanLaw. Say goodbye to data limitations and embrace unparalleled insights with our revolutionary reporting feature. Unlock your data—not just from LeanLaw, but from various sources—and effortlessly generate Excel and dashboard-ready business intelligence. ", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(LlSecondaryButton, {
                  class: "leanlaw-pro",
                  color: "warning",
                  onClick: getLeanLawPro
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("Get LeanLaw Pro", -1)]))]),
                  _: 1
                }), _createVNode(LlSecondaryButton, {
                  onClick: contactUs,
                  class: "contact-us"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("Contact Us", -1)]))]),
                  _: 1
                })])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "12",
                md: "7"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_img, {
                  class: "mx-auto",
                  "aspect-ratio": "1.5",
                  "lazy-src": _unref(image),
                  src: _unref(image)
                }, {
                  placeholder: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_v_progress_circular, {
                    color: "orange",
                    indeterminate: ""
                  })])]),
                  _: 1
                }, 8, ["lazy-src", "src"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), splashState.openUpgradePlanDialog ? (_openBlock(), _createBlock(UpgradePlanDialog, {
        key: 0,
        alerts: __props.alerts,
        onCloseUpgradePlanDialog: closeUpgradePlanDialog
      }, null, 8, ["alerts"])) : _createCommentVNode("", true), splashState.openUpgradeDialog ? (_openBlock(), _createBlock(UpgradeDialog, {
        key: 1,
        reportState: __props.reportState,
        userService: __props.userService,
        alerts: __props.alerts,
        tracking: __props.tracking,
        state: __props.state,
        stateParams: _ctx.stateParams,
        onCloseUpgradeDialog: closeUpgradeDialog
      }, null, 8, ["reportState", "userService", "alerts", "tracking", "state", "stateParams"])) : _createCommentVNode("", true)], 64);
    };
  }
};